import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Buyer } from '../../Models/Buyer';
import { SessionManager } from '../../services/SessionManager/SessionManager';

interface AuthState {
  isLoggedIn: boolean;
  buyer: Buyer | null;
}

// Initialize state based on SessionManager
const initialState: AuthState = {
  isLoggedIn: SessionManager.shared.isLoggedin(),
  buyer: SessionManager.shared.buyer || null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Buyer>) => {
      state.isLoggedIn = true;
      state.buyer = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.buyer = null;
    },
    updateBuyer: (state, action: PayloadAction<Buyer>) => {
      state.buyer = action.payload;
      SessionManager.shared.buyer = action.payload;
    },
  },
});

export const { login, logout, updateBuyer } = authSlice.actions;
export default authSlice.reducer;
